import { Injectable } from '@angular/core';
import { Headers, Http, ResponseContentType } from '@angular/http';
import { ApplicationUrlSettings } from '../settings/ApplicationUrlSettings';
import { HttpWrapperService } from '../services/http-wrapper/http-wrapper.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PhoneUtils } from '../utilities/PhoneUtils/PhoneUtils';

@Injectable()
export class VendorService {

  constructor(private http: HttpWrapperService) {

  }


  setLogo(formData) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/logo`;
    return this.http.patch(url, formData).toPromise().then(res => res.json());
  }

  getVendorInfoFromStorage() {
    try {
      var login = JSON.parse(localStorage.getItem('vendorlogin'));
      return login ? login.payload.vendor : null;
    } catch (e) {
      return null;
    }
  }

  saveAddress(address){
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/saved-address`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.post(url, address, { headers: headers }).toPromise().then(res => res.json());
  }
  

  getSavedAddress(savedid){
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/saved-address?savedid=${savedid}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  removeSavedAddress(id){
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/saved-address?id=${id}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.delete(url, { headers: headers }).toPromise().then(res => res.json());
  }

  reset(email, password, code) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/reset`;
    return this.http.post(url, {
      email: email,
      password: password,
      code: code
    }).toPromise().then(res => res.json());
  }

  sendResetCode(email) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/otp?email=${email}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getCustomerInfoFromStorage() {
    try {
      var login = JSON.parse(localStorage.getItem('vendorlogin'))
      return login.payload;
    } catch (e) {
      return null;
    }
  }


  searchCustomerList(query){
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customer-search?search=${query}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  getCustomerList(page, limit) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customer-list?page=${page}&limit=${limit}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  deleteCustomer(id, reason?: string){
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers?id=${encodeURIComponent(id)}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    });
    // Backend reads req.body.reason; always send a body so it is never undefined.
    return this.http.delete(url, {
      headers: headers,
      body: { reason: reason || null }
    }).toPromise().then(res => res.json());
  }

  getCustomerTrash() {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers/trash`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  restoreCustomer(savedid: number | string) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers/restore`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.post(url, { savedid, id: savedid }, { headers: headers }).toPromise().then(res => res.json());
  }

  permanentlyDeleteCustomer(savedid: number | string) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers/trash?id=${encodeURIComponent(String(savedid))}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.delete(url, { headers: headers }).toPromise().then(res => res.json());
  }

  /** Prefer savedid for company customers; otherwise customerid for registered. */
  private customerOwnerPayload(customer: { savedid?: number | string; customerid?: number | string }): { savedid?: number | string; customerid?: number | string } | null {
    if (customer && customer.savedid != null && customer.savedid !== '') {
      return { savedid: customer.savedid };
    }
    if (customer && customer.customerid != null && customer.customerid !== '') {
      return { customerid: customer.customerid };
    }
    return null;
  }

  setCustomerDiscount(payload: {
    savedid?: number | string;
    customerid?: number | string;
    discount_type: 'percentage' | 'flat';
    discount_value: number;
  }) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers/discount`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    });
    return this.http.put(url, payload, { headers: headers }).toPromise().then(res => res.json());
  }

  getCustomerDiscount(customer: { savedid?: number | string; customerid?: number | string }) {
    const owner = this.customerOwnerPayload(customer);
    if (!owner) {
      return Promise.reject(new Error('Customer id is required'));
    }
    const qs = owner.savedid != null
      ? `savedid=${encodeURIComponent(String(owner.savedid))}`
      : `customerid=${encodeURIComponent(String(owner.customerid))}`;
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers/discount?${qs}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  clearCustomerDiscount(customer: { savedid?: number | string; customerid?: number | string }) {
    const owner = this.customerOwnerPayload(customer);
    if (!owner) {
      return Promise.reject(new Error('Customer id is required'));
    }
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers/discount`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    });
    return this.http.delete(url, { headers: headers, body: owner }).toPromise().then(res => res.json());
  }

  private normalizeCustomerPhonePayload(customer: any) {
    const payload: any = { ...customer };
    if (customer && customer.phone != null && customer.phone !== '') {
      payload.phone = PhoneUtils.toTenDigitPhone(customer.phone);
    }
    if (Array.isArray(customer && customer.phones)) {
      const phones = customer.phones
        .map((p: any) => PhoneUtils.toTenDigitPhone(typeof p === 'string' ? p : (p && p.phone)))
        .filter(Boolean);
      payload.phones = phones;
      if (!payload.phone && phones.length) {
        payload.phone = phones[0];
      }
    } else {
      delete payload.phones;
    }
    return payload;
  }

  updateCustomer(customer){
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.patch(url, this.normalizeCustomerPhonePayload(customer), { headers: headers }).toPromise().then(res => res.json());
  }

  createCustomer(customer){
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.post(url, this.normalizeCustomerPhonePayload(customer), { headers: headers }).toPromise().then(res => res.json());
  }

  getCustomerPhones(savedid) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers/phones?savedid=${encodeURIComponent(savedid)}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  addCustomerPhone(payload: { savedid: number | string; phone: string; makePrimary?: boolean }) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers/phones`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    const body = {
      savedid: payload.savedid,
      phone: PhoneUtils.toTenDigitPhone(payload.phone),
      makePrimary: !!payload.makePrimary
    };
    return this.http.post(url, body, { headers: headers }).toPromise().then(res => res.json());
  }

  setPrimaryCustomerPhone(payload: { savedid: number | string; phone: string }) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers/phones/primary`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    const body = {
      savedid: payload.savedid,
      phone: PhoneUtils.toTenDigitPhone(payload.phone)
    };
    return this.http.patch(url, body, { headers: headers }).toPromise().then(res => res.json());
  }

  deleteCustomerPhone(savedid: number | string, phone: string) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers/phones?savedid=${encodeURIComponent(String(savedid))}&phone=${encodeURIComponent(PhoneUtils.toTenDigitPhone(phone))}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.delete(url, { headers: headers }).toPromise().then(res => res.json());
  }

  getAllCustomers() {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customers`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  login(payload) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/login`
    return this.http.post(url, payload).toPromise().then(res => res.json());
  }

  googleLogin(payload) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/google-login`
    return this.http.post(url, payload).toPromise().then(res => res.json());
  }

  register(payload) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/register`
    return this.http.post(url, payload).toPromise().then(res => res.json());
  }

  updateDbSettings(payload){
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/dbsettings`
    return this.http.patch(url, payload).toPromise().then(res => res.json());
  }

  updateClientSettings(payload) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/clientsettings`
    return this.http.patch(url, payload).toPromise().then(res => res.json());
  }

  getVendorInfoById(id) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor?id=${id}`
    return this.http.get(url).toPromise().then(res => res.json())
  }

  getVendorInfoByUrl(urlname) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor?url=${urlname}`
    return this.http.get(url).toPromise().then(res => res.json())
  }

  getOrderHistory(page = 1, limit = 10, startDate = null, endDate = null, status = null) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/order-history?page=${page}&limit=${limit}`;
    if (startDate) {
      url += `&startDate=${startDate}`;
    }
    if (endDate) {
      url += `&endDate=${endDate}`;
    }
    if (status) {
      url += `&status=${status}`;
    }
    let token = '';
    try {
      const vendorLogin = JSON.parse(localStorage.getItem('vendorlogin'));
      token = vendorLogin ? vendorLogin.token : '';
    } catch (e) {
      token = '';
    }
    const headers = new Headers({
      'Authorization': `Bearer ${token}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  getOrderDetails(orderId: string) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}trip/${orderId}`;
    let token = '';
    try {
      const vendorLogin = JSON.parse(localStorage.getItem('vendorlogin'));
      token = vendorLogin ? vendorLogin.token : '';
    } catch (e) {
      token = '';
    }
    const headers = new Headers({
      'Authorization': `Bearer ${token}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  // Fetch all orders for a customer by customerid, email, phone, or savedid
  getOrdersForCustomer(customerid: string, email: string, phone: string, savedid?: string) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/orders-for-customer?customerid=${customerid || ''}&email=${encodeURIComponent(email || '')}&phone=${encodeURIComponent(phone || '')}`;
    if (savedid) {
      url += `&savedid=${savedid}`;
    }
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  downloadCustomerListCSV(): Observable<Blob> {
    var url = `${ApplicationUrlSettings.NODE_API_URL}vendor/customer-list-csv`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers, responseType: ResponseContentType.Blob })
      .pipe(map(res => res.blob()));
  }

}
